/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Table,
} from '../../components/index';

const linhasPorPagina = 20;
const marcadorNaoPertenceCPF = 'Não associado ao CPF';

class ModalCadeiaDeNit extends Component {
  montaElosTableHeader = () => (
    [{ id: this.props.acao === 'novo' || this.props.acao === 'indeferidos' || this.props.acao === 'cumprir-exigencia' ? 'nit0' : 'idNit0', label: '' }]
  )

  montaColunas = () => {
    const bloqueiosTableHeader = this.montaEloNitTableHeader.slice();
    return bloqueiosTableHeader;
  }

  formatar = (nit, tipoNit) => {
    let nitFormatado = '';
    let retorno = '';
    if (nit) {
      nitFormatado = nit.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3.$4-$5');
    }
    retorno = nitFormatado;
    if ((this.props.acao !== 'novo' && tipoNit !== null && tipoNit === 3)) {
      retorno = `${retorno} ${marcadorNaoPertenceCPF}`;
    }
    // if ((this.props.acao === 'novo' && this.state.incluirMarcadorParaNit === nit)) {
    //   retorno = `${retorno} ${marcadorNaoPertenceCPF}`;
    // }
    return retorno;
  };

  exibirMensagemCPF = (tipoNit) => {
    if ((this.props.acao !== 'novo' && tipoNit !== null && tipoNit === 3)) {
      // retorno = `${retorno} ${marcadorNaoPertenceCPF}`;
      return (
        <React.Fragment>
          {(<div className="estadoNaoPago">Não associado ao CPF</div>)}
        </React.Fragment>
      );
    }
    return '';
  };

  montaListaElos = () => {
    const colunasPorPagina = 1;
    let pagina = 0;
    let linha = 0;
    let coluna = 0;
    const listaFormatada = [];
    listaFormatada[0] = {};
    if (this.props.elos === undefined || this.props.elos.length === 0) {
      listaFormatada.length = 0;
    } else {
      const listaNits = this.props.elos;
      if (this.props.acao === 'novo' || this.props.acao === 'indeferidos' || this.props.acao === 'cumprir-exigencia') {
        const indexNit = listaNits.findIndex(nit => (nit === this.props.nit));
        if (indexNit === -1 && this.props.nit !== null && this.props.nit !== undefined) {
          listaNits.unshift(this.props.nit);
          // if (this.props.dataMigracao !== null) {
          // this.setState({
          //   incluirMarcadorParaNit: this.props.nit,
          // });
          // }
        }
        listaNits.forEach((nit, index) => {
          const numeroNit = nit && nit.idNit ? nit.idNit.toString() : nit;
          listaFormatada[linha][`nit${coluna}`] = `${this.formatar(numeroNit, null)}`;
          if ((index + 1) % linhasPorPagina === 0) {
            if ((index + 1) % (linhasPorPagina * colunasPorPagina) === 0) {
              pagina += 1;
              linha = pagina * linhasPorPagina;
              coluna = 0;
              if (listaFormatada[linha] === undefined) {
                listaFormatada[linha] = {};
              }
            } else {
              linha = pagina * linhasPorPagina;
              coluna += 1;
              if (coluna % colunasPorPagina === 0) {
                coluna = 0;
              }
            }
          } else {
            linha += 1;
            if (listaFormatada[linha] === undefined) {
              listaFormatada[linha] = {};
            }
          }
        });
      } else {
        listaNits.forEach((item, index) => {
          const nit = item.idNit.toString();
          const paramTipoNit = item.tipoNit;
          listaFormatada[linha][`idNit${coluna}`] = this.formatar(nit, paramTipoNit);
          if ((index + 1) % linhasPorPagina === 0) {
            if ((index + 1) % (linhasPorPagina * colunasPorPagina) === 0) {
              pagina += 1;
              linha = pagina * linhasPorPagina;
              coluna = 0;
              if (listaFormatada[linha] === undefined) {
                listaFormatada[linha] = {};
              }
            } else {
              linha = pagina * linhasPorPagina;
              coluna += 1;
              if (coluna % colunasPorPagina === 0) {
                coluna = 0;
              }
            }
          } else {
            linha += 1;
            if (listaFormatada[linha] === undefined) {
              listaFormatada[linha] = {};
            }
          }
        });
      }
    }
    return listaFormatada;
  }
  options = {
    noDataText: 'Não existem NITs relacionados',
    hideSizePerPage: true,
    sizePerPage: linhasPorPagina,
  }
  handleClose = () => {
    this.props.handleModal('handleModalCadeiaDeNitModal');
  }
  modalCadeiaDeNitContent = () => (
    <React.Fragment>
      <div className="row">
        <Table
          bordered
          data={this.montaListaElos()}
          options={this.options}
          listaTableHeader={this.montaElosTableHeader()}
          pagination
          scrollTop="Top"
        />
      </div>
    </React.Fragment>
  );
  modalFooter = () => (
    <React.Fragment>
      <div />
    </React.Fragment>
  );
  render() {
    return (
      <Modal
        {...this.props}
        conteudomodal={this.modalCadeiaDeNitContent()}
        conteudofooter={this.modalFooter()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="NITS"
      />
    );
  }
}
ModalCadeiaDeNit.propTypes = {
  acao: PropTypes.string.isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  elos: PropTypes.arrayOf({
    value: PropTypes.string,
  }).isRequired,
  nit: PropTypes.string.isRequired,
  dataMigracao: PropTypes.string.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleDocumentSent: PropTypes.func,
}.isRequired;
export default ModalCadeiaDeNit;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalCadeiaDeNit.jsx